<template>
    <div class="treeview-node treeview-node--leaf treeview-node--click">
        <div class="treeview-node__root" @click.stop="toggle">
            <div v-for="i in level" :key="i" class="treeview-node__level"></div>
            <div v-if="!hasChildren && level !== 0" class="treeview-node__level"></div>
            <template v-if="hasChildren">
                <v-icon :class="['treeview-node__toggle', { 'treeview-node__toggle--open': isOpen, 'treeview-node__toggle--loading': isLoading }]" @click.stop="toggle">
                    {{ isLoading ? ICONS.LOADING : ICONS.MENU_DOWN }}
                </v-icon>
                <div class="treeview-node__content">
                    <div class="treeview-node__label">{{ item.name }}</div>
                    <v-badge outlined inline v-if="badgeText" x-small :content="badgeText" color="secondary"/>
                </div>
            </template>
            <template v-else>
                <div class="treeview-node__content" @click.stop="select">
                    <span class="treeview-node__label">{{ item.name }}</span>
                    <v-icon v-if="isLeaf" class="v-icon notranslate treeview-node__checkbox v-icon--link" @click.stop="select">
                        {{ isSelected ? ICONS.CHECKBOX_MARKED : ICONS.CHECKBOX_EMPTY }}
                    </v-icon>
                </div>
            </template>
        </div>

        <div v-if="hasChildren && isOpen" class="treeview-node__children">
            <TreeItem
                v-for="child in item.children"
                :key="child.id"
                :item="child"
                :selected="selected"
                :level="level + 1"
                :load-children="loadChildren"
                :parent-ids="[...parentIds, item.id]"
                :leaf-level="leafLevel"
                @select="$emit('select', $event)"
            />
        </div>
    </div>
</template>

<script>
import { ICONS } from '@/constants/icons';

export default {
    name: 'TreeItem',
    props: {
        item: {
            type: Object,
            required: true
        },
        selected: {
            type: Array,
            required: true
        },
        level: {
            type: Number,
            required: true
        },
        loadChildren: {
            type: Function
        },
        parentIds: {
            type: Array,
            required: true
        },
        leafLevel: {
            type: Number
        }
    },
    data: () => ({
        isOpen: false,
        isLoading: false,
        hasLoaded: false,
        ICONS
    }),
    computed: {
        hasChildren () {
            return !!this.item.children && (!!this.item.children.length || !!this.loadChildren);
        },
        isSelected () {
            return this.selected.find(item => item.id === this.item.id);
        },
        badgeText () {
            return this.selected?.filter(item => item.parents?.includes(this.item.id))?.length;
        },
        isLeaf () {
            return this.leafLevel !== undefined ? this.level === this.leafLevel : true;
        }
    },
    methods: {
        checkChildren () {
            return new Promise(resolve => {
                if (!this.item.children || this.item.children.length || !this.loadChildren || this.hasLoaded) return resolve();

                this.isLoading = true;
                resolve(this.loadChildren(this.item));
            }).then(() => {
                this.isLoading = false;
                this.hasLoaded = true;
            });
        },
        toggle (e) {
            e.stopPropagation();

            if (this.isLoading) return;

            this.checkChildren().then(() => {
                this.isOpen = !this.isOpen;
            });
        },
        select () {
            this.$emit('select', { ...this.item, parents: this.parentIds });
        }
    }
};
</script>

<style scoped lang="scss">
@import "./styles.css";
</style>
